import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useEnabledApps } from "../hooks/useEnabledApps";
import { resolveDefaultLanding } from "../lib/resolveDefaultLanding";

/**
 * At `/`: render the Intelligence Hub when the assistant app is enabled;
 * otherwise redirect to the resolved default landing. Keeps the default landing
 * reachable for orgs without the assistant, instead of showing the gated
 * "app disabled" screen at `/`.
 */
export function LandingRedirect({ children }: { children: ReactNode }) {
  const enabled = useEnabledApps();
  const target = resolveDefaultLanding(enabled);
  if (target !== "/") return <Navigate to={target} replace />;
  return <>{children}</>;
}
